import { useContext } from 'react';
import { StaffNotesContext } from './StaffNotesContext';

export const useStaffNotes = () => {
  const context = useContext(StaffNotesContext);
  if (context === null) {
    throw Error('Form context is not defined');
  }
  return context;
};
